import React, { useState, useEffect } from 'react';

import { ModalErrorAllYesRisks } from './errorAllYesRisks.styles';

export default function ErrorAllYesRisks(props) {
  const [errorAllYesRisks, setErrorAllYesRisks] = useState(props.showModalErrorAllYesRisks);

  useEffect(() => {
    setErrorAllYesRisks(props.showModalErrorAllYesRisks);
  }, [props.showModalErrorAllYesRisks]);

  const closeModal = () => {
    setErrorAllYesRisks(false);
    props.setErrorAllYesRisks(false);
  };

  return (
    <ModalErrorAllYesRisks showModalErrorAllYesRisks={errorAllYesRisks}>
      <div>
        <figure onClick={closeModal}>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
            alt="icono para cerrar la ventana"
          />
        </figure>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconoError.png`}
            alt="icono de aviso"
          />
        </figure>
        <p>
          Estimado Inversionista, hasta que no comprendas y aceptes los riesgos asociados a las
          inversiones en FinSphera no podrás invertir con nosotros.
        </p>
      </div>
    </ModalErrorAllYesRisks>
  );
}
